import { Injectable } from '@angular/core';

interface CameraSession {
  isAdHoc: boolean;
  sensorId: number;
  cameraSessionInfo: any;
  url?: string;
  player?: any;
}

@Injectable({
  providedIn: 'root'
})
export class FmvAttributeVisualizerService {
  private regularCameraSessions: { [id: string]: CameraSession } = {};
  private adHocCameraSessionNumber = 0;
  private adHocPlayers: { [id: string]: any } = {};
  private httpPlayers: { [id: string]: any } = {};
  private timeoutPromise: { [id: string]: any } = {};

  constructor() {}

  // Ad-hoc player management
  getAdHocCameraSessionNumber(): number {
    return this.adHocCameraSessionNumber;
  }

  incAdHocCameraSessionNumber(): void {
    this.adHocCameraSessionNumber++;
  }

  addToAdHocPlayers(number: string, player: any): void {
    this.adHocPlayers[number] = player;
  }

  getAdHocPlayer(number: string): any {
    return this.adHocPlayers[number];
  }

  deleteAdHocPlayer(number: string): void {
    delete this.adHocPlayers[number];
  }

  // Regular camera session management
  getRegularCameraSessions(): { [id: string]: CameraSession } {
    return this.regularCameraSessions;
  }

  // Timeout management
  deleteTimeout(cameraSessionId: string): void {
    if (this.timeoutPromise[cameraSessionId]) {
      clearTimeout(this.timeoutPromise[cameraSessionId]);
      delete this.timeoutPromise[cameraSessionId];
    }
  }

  // HLS Player refresh
  refreshHLSPlayer(id: string): void {
    const session = this.regularCameraSessions[id];
    this.disposePlayer(id);
    const elem = document.querySelector(`#camera-window${id} video`) as HTMLVideoElement;
    if (elem && session?.url) {
      // @ts-ignore
      const player = new (window as any).Hls();
      player.loadSource(session.url);
      player.attachMedia(elem);
      session.player = player;
    }
  }

  // HTTP player management
  addToHttpPlayers(sensorId: string, player: any): void {
    this.httpPlayers[sensorId] = player;
  }

  getHttpPlayer(sensorId: string): any {
    return this.httpPlayers[sensorId];
  }

  disposeHttpPlayer(sensorId: string): void {
    if (this.httpPlayers[sensorId]) {
      this.httpPlayers[sensorId].destroy();
    }
  }

  deleteHttpPlayer(sensorId: string): void {
    delete this.httpPlayers[sensorId];
  }

  // Player disposal
  disposePlayer(sensorId: string): void {
    const session = this.regularCameraSessions[sensorId];
    if (session?.player) {
      session.player.destroy();
    }
    if ((session as any)?.playerHLS) {
      (session as any).playerHLS.destroy();
    }
  }

  // Camera session stop (stub, implement with your backend)
  stopCameraSession(cameraSessionId: number, organizationId: number): Promise<any> {
    // Implement with your backend API call
    return Promise.resolve();
  }
}